module.exports = __webpack_public_path__ + "img/IMG_1645_FoamcoreMatted_MockedUp.db863daf.jpg";